module.exports = __webpack_public_path__ + "static/media/Group 21.55a2ae55.png";